module.exports = __webpack_public_path__ + "img/capello.edaf3046.png";